import _ from 'lodash';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import uuidv4 from 'uuid/v4';
import { showErrorModal } from '../../../actions/uiActions';
import { myAxaFetchWithToken } from '../../../utils/myAxaFetchWithToken';
import {
  CHANGE_CUSTOMER_PROFILE_LOADING,
  FETCH_CUSTOMER_PROFILE_FEATURES,
  FETCH_CUSTOMER_PROFILE_FEATURES_FAILURE,
  FETCH_CUSTOMER_PROFILE_FEATURES_SUCCESS,
} from '../actions/customerProfileAction';
import {
  getCustomerProfileFeatureUrl,
  getCustomerProfileFeaturesApi,
  getCustomerProfileFeaturesConfig,
  getCustomerSettingFeaturesConfig,
} from '../selectors/customerProfileSelectors';

function* fetchCustomerProfile() {
  const customerProfileFeaturesConfig = yield select(
    getCustomerProfileFeaturesApi,
  );
  if (customerProfileFeaturesConfig.length > 0) return;

  const customerProfileFeatureUrl = yield select(getCustomerProfileFeatureUrl);
  const profileFeatures = yield select(getCustomerProfileFeaturesConfig);
  const settingFeatures = yield select(getCustomerSettingFeaturesConfig);
  try {
    if (!customerProfileFeatureUrl) {
      return;
    }
    yield put({ type: CHANGE_CUSTOMER_PROFILE_LOADING, isLoading: true });
    console.log("Fetching customer permissions")
    // const res = { status: 200, json: () => require('../mock/customerProfileFeature.json') }
    const res = yield call(myAxaFetchWithToken, customerProfileFeatureUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-axahk-msgid': uuidv4(),
      },
    });
    const data = yield res.json();
    if (!data) throw new Error();
    const response = _.get(
      data,
      'retrieveCustomerProfilePermissionResponse',
      {},
    );
    const features = _.get(response, 'features', []);
    const featuresItems = {
      profileFeatures: profileFeatures
        .filter((item: any) =>
          features.find((feature: any) => item.id === feature.feature),
        )
        .sort(
          (a: any, b: any) => Number.parseInt(a.rank) - Number.parseInt(b.rank),
        )
        .map((f: any) => f.id),
      settingFeatures: settingFeatures
        .filter((item: any) =>
          features.find((feature: any) => item.id === feature.feature),
        )
        .sort(
          (a: any, b: any) => Number.parseInt(a.rank) - Number.parseInt(b.rank),
        )
        .map((f: any) => f.id),
    };
    const { lastNm, dob, idDocNo, genderCd, lastUpdateDate } = response;
    yield put({
      type: FETCH_CUSTOMER_PROFILE_FEATURES_SUCCESS,
      featuresItems,
      userData: { lastNm, dob, idDocNo, genderCd },
      lastUpdateDate,
    });
    yield put({ type: CHANGE_CUSTOMER_PROFILE_LOADING, isLoading: false });
  } catch (e) {
    yield put(showErrorModal());
    yield put({ type: FETCH_CUSTOMER_PROFILE_FEATURES_FAILURE, error: e });
    yield put({ type: CHANGE_CUSTOMER_PROFILE_LOADING, isLoading: false });
  }
}

function* customerProfileSaga() {
  yield takeLatest(FETCH_CUSTOMER_PROFILE_FEATURES, fetchCustomerProfile);
  // yield take(FRAME_APP_MOUNTED);
  // yield fork(fetchCustomerProfile);
}

export default customerProfileSaga;
